import BNLink from "../../../../BnComponents/BNLink/BNLink";
import Media from "../../../../CmsComponents/Media/Media";
import React from "react";
import RichText from "../../../../CmsComponents/RichText/RichText";
import { BNBox } from "@bn-monorepo/js-packages";
import { useTheme } from "@mui/material/styles";
import Button from "../Button/Button";
import { Image } from "../Section/Section";

interface Section {
  title: string;
  descriptions: string;
  button?: string;
  href?: string;
  image?: Image;
  isSpa: boolean;
  linkOnImageAndTitleIsSpa?: boolean;
  linkOnImageAndTitleHref?: string;
}

interface Props {
  title?: string;
  sections: Section[];
  enabled?: boolean;
}

const headerSx = {
  fontSize: "1.4em",
  lineHeight: 1,
  m: 0,
} as const;

const linkResetStyle: React.CSSProperties = {
  color: "var(--mui-palette-text-primary)",
  textDecoration: "none",
};

const CardSectionBig: React.FC<Props> = (props) => {
  const { title, sections, enabled } = props;
  const theme = useTheme();

  if (!enabled) return null;
  return (
    <BNBox
      component={"section"}
      sx={{
        px: 2,
        my: 2,
        mx: 0,
      }}
    >
      {sections && (
        <BNBox
          sx={{
            display: "grid",
            gap: "3.2rem",
            gridTemplateColumns: "1fr",
            justifyContent: "center",
            maxWidth: "120rem",
            mx: "auto",
            my: 0,
            [theme.breakpoints.up("md")]: {
              gridTemplateColumns: "1fr 1fr",
            },
            [theme.breakpoints.down("md")]: {
              maxWidth: "60rem",
            },
          }}
        >
          {title && (
            <BNBox
              component={"h2"}
              sx={{
                fontSize: "3em",
                textAlign: "center",
                lineHeight: 1.2,
                m: "1em 0 0 0",
                placeSelf: "center",
              }}
            >
              {title}
            </BNBox>
          )}
          {sections.map((section, index) => (
            <BNBox
              component={"section"}
              key={`section-${index}`}
              sx={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "background.paper",
                borderRadius: `calc(8 * ${theme.vars.shape.borderRadius})`,
              }}
            >
              {section.image &&
                (section.linkOnImageAndTitleHref ? (
                  <BNLink
                    isSpa={section.linkOnImageAndTitleIsSpa || false}
                    href={section.linkOnImageAndTitleHref}
                    tabIndex={(section.button && section.href) || title ? -1 : undefined}
                  >
                    <Media
                      AltText={section.image.alt}
                      imagePath={section.image.url}
                      noWrapper={true}
                      width={section.image.width}
                      height={section.image.height}
                      sx={{
                        width: "100%",
                        borderTopLeftRadius: `calc(8 * ${theme.vars.shape.borderRadius})`,
                        borderTopRightRadius: `calc(8 * ${theme.vars.shape.borderRadius})`,
                      }}
                    />
                  </BNLink>
                ) : (
                  section.image && (
                    <Media
                      AltText={section.image.alt}
                      imagePath={section.image.url}
                      noWrapper={true}
                      width={section.image.width}
                      height={section.image.height}
                      sx={{
                        width: "100%",
                        borderTopLeftRadius: `calc(8 * ${theme.vars.shape.borderRadius})`,
                        borderTopRightRadius: `calc(8 * ${theme.vars.shape.borderRadius})`,
                      }}
                    />
                  )
                ))}
              <BNBox
                sx={{
                  height: "100%",
                  p: "1em",
                  [theme.breakpoints.up("md")]: {
                    p: "3em 3em 1em 3em",
                  },
                }}
              >
                {title && section.linkOnImageAndTitleHref ? (
                  <BNLink
                    isSpa={section.linkOnImageAndTitleIsSpa || false}
                    href={section.linkOnImageAndTitleHref}
                    tabIndex={section.button && section.href ? -1 : undefined}
                  >
                    <BNBox component={"h3"} sx={headerSx}>
                      {section.title}
                    </BNBox>
                  </BNLink>
                ) : (
                  title && (
                    <BNBox component={"h3"} sx={headerSx}>
                      {section.title}
                    </BNBox>
                  )
                )}
                {!title && section.linkOnImageAndTitleHref ? (
                  <BNLink
                    isSpa={section.linkOnImageAndTitleIsSpa || false}
                    href={section.linkOnImageAndTitleHref}
                    tabIndex={section.button && section.href ? -1 : undefined}
                    style={linkResetStyle}
                  >
                    <BNBox component={"h3"} sx={headerSx}>
                      {section.title}
                    </BNBox>
                  </BNLink>
                ) : (
                  !title && (
                    <BNBox component={"h3"} sx={headerSx}>
                      {section.title}
                    </BNBox>
                  )
                )}
                <RichText sx={{ fontSize: "1em", my: "1em" }} html={section.descriptions} />
              </BNBox>
              {section.href && section.button && (
                <BNBox
                  sx={{
                    p: 1,
                    marginBottom: 2,
                    textAlign: "center",
                    [theme.breakpoints.down("md")]: {
                      p: 0,
                    },
                  }}
                >
                  <Button
                    text={section.button}
                    href={section.href}
                    isSpa={section.isSpa}
                    type="blue"
                    textAlign={"center"}
                  />
                </BNBox>
              )}
            </BNBox>
          ))}
        </BNBox>
      )}
    </BNBox>
  );
};
export default CardSectionBig;
